const INTEGRATIONS = {
	GMAPS: "AIzaSyCKQbJx_No_OjUlQCU21dU-dfFcjPEVQO0",
	RECAPTCHA_SITE: "6Lf-D9okAAAAAO0lodMswSacqVdQaJh2mconlqJA",
};

export default INTEGRATIONS;
